var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c(_vm.currentComponent,{tag:"component",on:{"createPin":_vm.createPin,"confirmPin":_vm.confirmPin,"authPin":_vm.authPin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }